import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import WindowUtil from './WindowUtil';

export default class FrontPage {
   static getInstance() {
      if (!FrontPage.instance) {
         FrontPage.instance = new FrontPage();
      }
      return FrontPage.instance;
   }

   constructor() {
      this.windowUtil = WindowUtil.getInstance();
      this.initGsap();
      FrontPage.instance = this;  // インスタンスを保存
   }

   initGsap() {
      gsap.registerPlugin(ScrollTrigger);

      // Aboutセクションの背景画像をスクロールに応じて動かす
      gsap.to("#about-gara", {
         yPercent: -80,
         ease: "none",
         scrollTrigger: {
            trigger: "#about-section",
            start: "top 50%",
            end: "bottom top",
            scrub: true,
            // markers: true, // デバッグ用
         }
      });

      // // メディアクエリに応じた処理
      // this.handleMediaQueries();
      // // リサイズ時にも再評価する
      // window.addEventListener('resize', this.handleMediaQueries.bind(this));

      // Sectionタイトル(About)用
      document.querySelectorAll("[data-anim-1-wrap]").forEach((el) => {
         const tlAnim1 = gsap.timeline({
            scrollTrigger: {
               trigger: el,  // 個別の要素ごとにトリガーを設定
               start: "top 80%",
               toggleActions: "play none none none",
            }
         });
         tlAnim1.fromTo(el,
            {
               opacity: 0,
               xPercent: -100,
            },
            {
               opacity: 1,
               xPercent: 0,
               backgroundColor: "#000",
               duration: 0.2,
               ease: "power2.out"
            }
         );
         const anim1 = el.querySelector("[data-anim-1]");
         if (anim1) {
            tlAnim1.to(anim1, {
               opacity: 1,
               duration: 0.3,
               ease: "power2.inOut",
            }, "-=0.1");
         }
      });

      // Sectionタイトル(content)用
      gsap.fromTo("[data-anim-2]",
         { xPercent: 0 },  // 初期状態: 画像を完全に覆っている
         {
           xPercent: 100,
           duration: 0.5,
           ease: "power2.out",
           scrollTrigger: {
             trigger: "[data-anim-2]",  // トリガーとなる要素
             start: "top 80%",
             toggleActions: "play none none none",
             // markers: true,
           }
         }
       );

      // テキスト用
      document.querySelectorAll("[data-anim-3-wrap]").forEach((el, index) => {
         const tlAnim2 = gsap.timeline({
            scrollTrigger: {
               trigger: el, // 個別の要素ごとにトリガーを設定
               start: "top 80%",
               toggleActions: "play none none none",
            }
         });
         // 黒い矩形のスライドインアニメーション
         tlAnim2.fromTo(el,
            {
               opacity: 0,
               xPercent: -100,
            },
            {
               opacity: 1,
               xPercent: 0,
               backgroundColor: "#000",
               duration: 0.2,
               ease: "power2.out"
            }
         );
         const anim2 = el.querySelector("[data-anim-3]");
         if (anim2) {
            tlAnim2.to(anim2, {
               opacity: 1,
               duration: 0.2,
               ease: "power2.inOut",
            }, "-=0.1");
         }
      });

      // 背景スケールアニメーションの設定
      gsap.fromTo("#anim-bg-scale",
         { scale: 0.9 },
         {
            scale: 1.025,
            borderRadius: 0,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
               trigger: "#anim-bg-scale",
               start: "top bottom",
               end: "top 10%",
               scrub: true,
            }
         }
      );

      // パルスアニメーションの作成
      document.querySelectorAll('[data-anim-img-pulse]').forEach((img) => {
         const tlPulse = gsap.timeline({
            scrollTrigger: {
               trigger: img,
               start: "top 75%",
               // onEnter: () => {
               //    tlPulse.restart();  // アニメーションをリスタートする
               // }
            }
         });
         tlPulse.to(img, {
            scale: 1.2,
            duration: 0.3,
            ease: "power1.inOut",
            yoyo: true, // アニメーションの往復を実現
            repeat: 1,  // 1回のリピート
         });
      });

      // rotateアニメーションの作成
      document.querySelectorAll('[data-anim-img-rotate]').forEach((img) => {
         gsap.set(img, { rotation: -30 }); // アニメーション前に初期状態を-30度に設定
         gsap.to(img, {
            rotation: 0, // 0度の位置まで回転
            duration: 2,
            ease: "elastic.out(1, 0.3)", // 振動の強さ, 減衰
            scrollTrigger: {
               trigger: img,
               start: "top 80%",
               toggleActions: "play none none none", // 一回だけ再生
            },
         });
      });

      // MVの画像スライド
      const imagesMv = document.querySelectorAll("[data-images-mv] picture");
      const tlImagesMv = gsap.timeline({ repeat: -1 });  // 無限ループ
      imagesMv.forEach((img, index) => {
         tlImagesMv.set(img, // カットイン
            {
               visibility: "visible",
               zIndex: 10,
            },
            index * 0.8
         )
         .set(img, // カットアウト
            {
               visibility: "hidden",
               zIndex: 0,
            },
            index * 0.8 + 0.8
         );
      });

      // MVの文字画像切り替え
      const imagesMvText = document.querySelectorAll("[data-images-mv-text] img");
      const tlImagesMvText = gsap.timeline({ repeat: -1 });  // 無限ループ
      imagesMvText.forEach((img, index) => {
         // 各画像を2秒間隔で順番に表示
         tlImagesMvText.set(img, // カットイン
            {
               opacity: 1,
               visibility: "visible",
            },
            index * 0.6
         )
         .set(img, // カットアウト
            {
               opacity: 0,
               visibility: "hidden",
            },
            index * 0.6 + 0.6
         );
      });

      // Contactの矢印アニメーション
      const imagesNeon = document.querySelectorAll('[data-anim-neon]');
      // タイムラインを作成
      const tlNeon = gsap.timeline({ repeat: -1});  // 無限ループと点滅を設定
      imagesNeon.forEach((img, index) => {
         // 各画像を最初に薄く表示
         gsap.set(img, { opacity: 1 });
         // 各画像のアニメーションを設定（順番に点灯）
         tlNeon.to(img, {
            opacity: 0.3,               // 完全に点灯
            duration: 0.2,            // 点灯にかける時間
            ease: "power2.inOut",     // 自然な点灯効果
         }, index * 0.2)             // 0.2秒ずつ遅らせて順番に点灯
         .to(img, {
            opacity: 1,             // 再度薄く表示
            duration: 0.2,            // 消灯にかける時間
            ease: "power2.inOut",
         }, index * 0.2 + 0.2);      // 点灯後に少し消灯
      });
   }

   // NOTE: ScrollTrigger.matchMedia({ は非推奨
   handleMediaQueries() {
      if (this.windowUtil.matchMediaQueryXsmall.matches) {
         // Xsmall screen size detected
         console.log("Xsmall screen size detected");
         // Xsmallサイズ用の処理をここに記述
      } else if (this.windowUtil.matchMediaQuerySmall.matches) {
         // Small screen size detected
         console.log("Small screen size detected");
         // Smallサイズ用の処理をここに記述
      } else if (this.windowUtil.matchMediaQueryMedium.matches) {
         // Medium screen size detected
         console.log("Medium screen size detected");
         // Mediumサイズ用の処理をここに記述
      }
      // 他のサイズも追加可能
   }
};
